'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.yearsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/yearsAgo.js
// module id = 364
// module chunks = 0